import React from 'react';
import { FormSection } from 'redux-form';
import { Row, Col, Button } from 'react-bootstrap';

import Column from './Column';
import FieldSection from './FieldSection';
import ArrayActions from './ArrayActions';
import ArrayError from './ArrayError';
import AssetSection from './AssetSection';

const RenderAssetArray = ({ fields, asset, meta, readOnly }) => {
  const addField = () => fields.push({});
  const { opts } = asset || {};
  return (
    <Column field={asset}>
      <div className="form-section-add">
        {!readOnly && (
          <Button onClick={addField} bsStyle="hollow-info" bsSize="sm" className="pull-right">
            <span className="ti ti-plus" /> {opts.arrayButtonText || 'section'}
          </Button>
        )}
        <h3>{opts.label}</h3>
        {!readOnly && (
          <ArrayError {...meta} />
        )}
      </div>
      {opts.helpText && (
        <div className="note">
          {opts.helpText}
        </div>
      )}
      {/* potential indent */}
      {fields.map((s, index) => {
        return (
          <div className="section-group">
            {!readOnly && (
              <div className="section-actions">
                <ArrayActions fields={fields} index={index} />
              </div>
            )}
            <Row key={index}>
              <Col sm={12}>
                <Row>
                  {asset.fields.map((f, i) => {
                    if (f.isAsset) return (
                      <AssetSection key={i} asset={f} readOnly={readOnly} />
                    )
                    return (
                      <FormSection key={i} name={s}>
                        <FieldSection field={f} readOnly={readOnly} />
                      </FormSection>
                    )
                  })}
                </Row>
              </Col>
            </Row>
          </div>
        )
      })}
    </Column>
  )
}


export default RenderAssetArray;



// WEBPACK FOOTER //
// ./src/components/routes/assets/asset-form/RenderAssetArray.js